import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Select} from "antd"
import {Label} from "reactstrap"

const {Option} = Select

class MultiSelect extends Component {
    _handleChange = async (value) => {
        await this.typeSelect.blur()

        const {onChange} = this.props

        if (typeof onChange === 'function') {
            onChange(value)
        }
    }

    render() {
        const {lists, field, value, placeholder, allowClear} = this.props

        return (
            <div className="MultiSelect">
                {field && <Label>{field}</Label>}
                <Select
                    mode="multiple"
                    style={{minWidth: '300px'}}
                    placeholder={placeholder || ''}
                    defaultValue={value}
                    ref={(select) => this.typeSelect = select}
                    onChange={this._handleChange}
                    allowClear={allowClear}
                >
                    {
                        lists.map(item => {
                            if (typeof item === 'object' && !!item) {
                                return <Option key={item.value} value={item.value}>{item.name}</Option>
                            }
                            return <Option key={item}>{item}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

MultiSelect.propTypes = {
    value: PropTypes.array,
    lists: PropTypes.array.isRequired,
    field: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default MultiSelect
